window.addEventListener('resize', function () {
    let windowHeight = window.innerHeight + "px";
     document.querySelector("body").style.cssText = `height: ` + windowHeight + ``;
});